module.exports = __webpack_public_path__ + "static/media/imageplaceholder.bb4b1ae9.png";